import React from "react";
var __jsx = React.createElement;
import { twMerge } from "tailwind-merge";
var SingleTitleStep = function SingleTitleStep(_ref) {
  var _ref$isDone = _ref.isDone,
    isDone = _ref$isDone === void 0 ? false : _ref$isDone,
    title = _ref.title,
    _ref$currentStep = _ref.currentStep,
    currentStep = _ref$currentStep === void 0 ? false : _ref$currentStep;
  return /*#__PURE__*/React.createElement("div", {
    className: [currentStep ? twMerge("!text-[#004cae] !relative after:content-[''] after:block after:!bg-[#004cae]") : undefined, isDone ? twMerge("!text-[#004cae] after:content-[''] after:block after:!bg-[#00B362]") : undefined, "font-bold bold w-full relative pb-[15px] flex items-center justify-center text-[11px] text-[#6c7a8d] leading-8 sm:w-[calc(100%/3)] sm:text-sm", "after:content-[''] after:block after:h-[3px] after:w-full after:rounded-[1.5px] after:bg-[#dae5f4] after:absolute after:bottom-0 after:left-0"].join(" ")
  }, title);
};
export default SingleTitleStep;